import {useMutation} from "react-query";
import {useNavigate} from "react-router-dom";
import Alert from "react-s-alert";
import {HubAndSpokeService} from "../../../services/HubAndSpokeService";

export const useCreateEventTrigger = () => {
  const navigate = useNavigate();
  return useMutation(
    async (body: {
      document: string;
      facilities: Array<string>;
      template_field_id: string;
      sftp_config_id: string;
      document_path: string;
    }) => {
      const response = await HubAndSpokeService.createEventTrigger(body);
      return response;
    },
    {
      onSuccess: () => {
        Alert.success("Event trigger successfully created!");
        navigate("/admin/hub-and-spoke/event-triggers");
      },
      onError: (err: any) => {
        Alert.error(err?.data?.detail);
      },
    },
  );
};
